function loadScript(e) {
  return new Promise((t, s) => {
    let i = document.createElement("script");
    (i.src = e), (i.onload = t), (i.onerror = s), document.body.appendChild(i);
  });
}
if (!customElements.get("cart-drawer-disclosure")) {
  class e extends DetailsDisclosure {
    constructor() {
      super(),
        (this.openBtn = this.querySelector("summary")),
        (this.closeBtn = this.querySelector(".js-close")),
        (this.overlay = document
          .getElementById("cart-drawer")
          .querySelector(".overlay"));
    }
    handleClick(e) {
      e.target.matches(".js-close") && this.close();
    }
    open() {
      this.overlay.classList.add("is-visible"),
        super.open(),
        trapFocus(this),
        (this.clickHandler = this.clickHandler || this.handleClick.bind(this)),
        (this.keyupHandler = (e) => "Escape" === e.key && this.close()),
        this.addEventListener("click", this.clickHandler),
        this.addEventListener("keyup", this.keyupHandler),
        this.overlay.addEventListener("click", this.clickHandler);
    }
    close() {
      this.overlay.classList.remove("is-visible"),
        super.close(),
        removeTrapFocus(this.openBtn),
        this.removeEventListener("click", this.clickHandler),
        this.removeEventListener("keyup", this.keyupHandler),
        this.overlay.removeEventListener("click", this.clickHandler);
    }
  }
  customElements.define("cart-drawer-disclosure", e);
}
if (!customElements.get("cart-drawer")) {
  class t extends SideDrawer {
    constructor() {
      super(), this.init(), this.bindEvents();
    }
    disconnectedCallback() {
      document.removeEventListener(
        "dispatch:cart-drawer:refresh",
        this.refreshHandler
      ),
        document.removeEventListener(
          "dispatch:cart-drawer:open",
          this.openDrawerViaEventHandler
        ),
        document.removeEventListener(
          "dispatch:cart-drawer:close",
          this.closeDrawerViaEventHandler
        ),
        Shopify.designMode &&
          (document.removeEventListener(
            "shopify:section:select",
            this.sectionSelectHandler
          ),
          document.removeEventListener(
            "shopify:section:deselect",
            this.sectionDeselectHandler
          )),
        this.dcbLoadedHandler &&
          document.removeEventListener(
            "shopify:payment_button:loaded",
            this.dcbLoadedHandler
          ),
        window.removeEventListener("pageshow", t.handlePageshow);
    }
    init() {
      let e = document.getElementById("cart-icon");
      e &&
        (e.setAttribute("role", "button"),
        e.setAttribute("aria-haspopup", "dialog"),
        e.addEventListener("click", (t) => {
          t.preventDefault(), this.open(e);
        }),
        e.addEventListener("keydown", (t) => {
          " " === t.key && (t.preventDefault(), this.open(e));
        }));
    }
    bindEvents() {
      Shopify.designMode &&
        ((this.sectionSelectHandler = this.handleSectionSelect.bind(this)),
        (this.sectionDeselectHandler = this.handleSectionDeselect.bind(this)),
        document.addEventListener(
          "shopify:section:select",
          this.sectionSelectHandler
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this.sectionDeselectHandler
        )),
        (this.openDrawerViaEventHandler =
          this.handleDrawerOpenViaEvent.bind(this)),
        (this.closeDrawerViaEventHandler = this.close.bind(this, null)),
        document.addEventListener(
          "dispatch:cart-drawer:open",
          this.openDrawerViaEventHandler
        ),
        document.addEventListener(
          "dispatch:cart-drawer:close",
          this.closeDrawerViaEventHandler
        ),
        (this.refreshHandler = this.refresh.bind(this)),
        document.addEventListener(
          "dispatch:cart-drawer:refresh",
          this.refreshHandler
        ),
        window.addEventListener("pageshow", t.handlePageshow);
    }
    static handlePageshow(e) {
      e.persisted &&
        document.dispatchEvent(
          new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: !0,
            cancelable: !1,
          })
        );
    }
    handleSectionSelect(e) {
      e.target === this.closest(".shopify-section") && this.open();
    }
    handleSectionDeselect(e) {
      e.target === this.closest(".shopify-section") && this.close();
    }
    handleDrawerOpenViaEvent(e) {
      this.open(e.detail ? e.detail.opener : null);
    }
    open(e, t) {
      let s = document.querySelector('quick-add-drawer[aria-hidden="false"]');
      s && s.close(), super.open(e, t);
    }
    async refresh(e) {
      try {
        let t = this.querySelector("cart-items");
        if (t && !e) t.refresh();
        else {
          let s = this.getSectionsToRender().map((e) => e.section),
            i = await fetch(`?sections=${s.join(",")}`),
            r = await i.json();
          this.renderContents({ sections: r }, !1);
        }
      } catch (n) {
        console.log(n),
          this.dispatchEvent(
            new CustomEvent("on:cart:error", {
              bubbles: !0,
              detail: { error: this.errorMsg.textContent },
            })
          );
      }
    }
    async renderContents(e, s = !0) {
      this.scriptsLoaded ||
        (document.querySelector(`script[src="${theme.scripts.cartItems}"]`) ||
          (await loadScript(theme.scripts.cartItems)),
        !document.querySelector(
          `script[src="${theme.scripts.shippingCalculator}"]`
        ) &&
          this.dataset.shippingCalculator &&
          (await loadScript(theme.scripts.countryProvinceSelector),
          await loadScript(theme.scripts.shippingCalculator)),
        (this.scriptsLoaded = !0)),
        this.getSectionsToRender().forEach((s) => {
          let i = document.getElementById(s.id);
          i &&
            (i.innerHTML = t.getElementHTML(e.sections[s.section], s.selector));
        }),
        s &&
          null === this.getAttribute("open") &&
          setTimeout(() => this.open());
    }
    getSectionsToRender() {
      return [
        {
          id: "cart-drawer",
          section: this.closest(".shopify-section").id.replace(
            "shopify-section-",
            ""
          ),
          selector: "cart-drawer",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
      ];
    }
    static getElementHTML(e, t) {
      let s = document.createElement("template");
      return (s.innerHTML = e), s.content.querySelector(t).innerHTML;
    }
  }
  customElements.define("cart-drawer", t);
}
